import _ from 'lodash';
export { getRegionTreeData } from './region'
export const bindThrottle = _.throttle(function(func) {
  func
},2000,{ leading: true, trailing: false })


// WEBPACK FOOTER //
// ./src/utils/index.js